<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<h1 class="toc-header"><span class="bold">Contents</span></h1>
<h2 class="toc1"><a href="#/xhtml/05_Acknowledgements"><em class="italic">Acknowledgements</em></a></h2>
<h2 class="toc1a"><a href="#/xhtml/06_Introduction"><em class="italic">Introduction</em></a></h2>
<h2 class="toc"><a href="#/xhtml/07_Chapter01"><span class="toc-hang"><span class="bold">Chapter 1</span></span> The Foot Guards</a></h2>
<h2 class="toc"><span href="#/xhtml/08_Chapter02" title="Link target outside of Sample"><span class="toc-hang"><span class="bold">Chapter 2</span></span> The Line Infantry</span></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter03" title="Link target outside of Sample"><span class="toc-hang"><span class="bold">Chapter 3</span></span> The Scottish Infantry</span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter04" title="Link target outside of Sample"><span class="toc-hang"><span class="bold">Chapter 4</span></span> The Light Infantry</span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter05" title="Link target outside of Sample"><span class="toc-hang"><span class="bold">Chapter 5</span></span> Royal Veteran Battalions and Fencible Regiments</span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter06" title="Link target outside of Sample"><span class="toc-hang"><span class="bold">Chapter 6</span></span> The British Troops in Canada</span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter07" title="Link target outside of Sample"><span class="toc-hang"><span class="bold">Chapter 7</span></span> The British Troops in the West Indies</span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter08" title="Link target outside of Sample"><span class="toc-hang"><span class="bold">Chapter 8</span></span> The British Troops in Africa and Australia</span></h2>
<h2 class="toc"><span href="#/xhtml/15_Chapter09" title="Link target outside of Sample"><span class="toc-hang"><span class="bold">Chapter 9</span></span> The British Troops in India</span></h2>
<h2 class="toc"><span href="#/xhtml/16_Chapter10" title="Link target outside of Sample"><span class="toc-hang"><span class="bold">Chapter 10</span></span> Foreign Troops in British Service</span></h2>
<h2 class="toc"><span href="#/xhtml/17_Chapter11" title="Link target outside of Sample"><span class="toc-hang"><span class="bold">Chapter 11</span></span> The King’s German Legion</span></h2>
<h2 class="toc"><span href="#/xhtml/18_Chapter12" title="Link target outside of Sample"><span class="toc-hang"><span class="bold">Chapter 12</span></span> Uniforms and Equipment</span></h2>
<h2 class="toc1"><span href="#/xhtml/19_Bib" title="Link target outside of Sample"><em class="italic">Bibliography</em></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?02e62598